import React, { Component } from "react"
import PropTypes from "prop-types"

const buildThresholdList = steps => {
  var thresholds = []
  for (var i = 1.0; i <= steps; i++) {
    var ratio = i / steps
    thresholds.push(ratio)
  }
  thresholds.push(0)
  return thresholds
}

const listenToIntersections = (element, callback, options) => {
  let io
  if (
    typeof io === "undefined" &&
    typeof window !== "undefined" &&
    window.IntersectionObserver
  ) {
    // io = new window.IntersectionObserver(callback, options)
    io = new IntersectionObserver(callback, options)
  }
  io.observe(element)
  return io
}

export default class IntersectionObserverWrapper extends Component {
  constructor(props) {
    super(props)
    // Always not visible while server rendering.
    this.state = {
      IOSupported: false,
    }
    this.ref = React.createRef()
  }

  async componentDidMount() {
    // Default values
    let IOSupported = false

    // Intersection Observer polyfill
    if (typeof window !== "undefined" && !window.IntersectionObserver) {
      await import("intersection-observer").then(() => {
        console.log("IntersectionObserver polyfill injected.")
      })
    }
    // Check if browser (now) supports IntersectionObserver
    if (typeof window !== "undefined" && window.IntersectionObserver) {
      IOSupported = true
    }

    this.setState(
      {
        IOSupported,
      },
      this.listenToIntersections
    )
  }

  listenToIntersections = () => {
    const options = {
      root: this.props.root,
      rootMargin: this.props.rootMargin,
      threshold: buildThresholdList(this.props.thresholdSteps),
    }
    this.io = listenToIntersections(
      this.ref.current,
      this.props.callback,
      options
    )
  }

  componentWillUnmount() {
    this.io.disconnect()
  }

  render() {
    // TODO: pass the isVisible and hasBeenVisible state value back into the children
    return (
      <div id={this.props.id} ref={this.ref}>
        {this.props.children}
      </div>
    )
  }
}

IntersectionObserverWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  thresholdSteps: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
  root: PropTypes.element,
  rootMargin: PropTypes.string,
  id: PropTypes.string,
}

IntersectionObserverWrapper.defaultProps = {
  root: null,
  rootMargin: "0px",
  thresholdSteps: 3,
}
